import { useNavigate } from "react-router-dom";

interface IWinner {
  text: string;
  score: number;
  oppScore: number;
}

function Winner({ text, score, oppScore }: IWinner) {
  const navigate = useNavigate();
  
  const isWin = text === "Victory";
  const isLoss = text === "Defeat";
  const mainColor = isWin ? "text-green-400" : isLoss ? "text-red-400" : "text-gray-400";
  const bgGradient = isWin ? "from-green-500/20 to-transparent" : isLoss ? "from-red-500/20 to-transparent" : "from-gray-500/20 to-transparent";

  return (
    <div className="w-full max-w-[360px] bg-[#101020]/90 backdrop-blur-xl border border-white/5 rounded-[24px] overflow-hidden shadow-2xl relative z-10 flex flex-col animate-[fade-in-up_0.6s_ease_both]">
      
      {/* Dynamic Header Glow */}
      <div className={`absolute top-0 left-0 w-full h-32 bg-gradient-to-b ${bgGradient} opacity-50 pointer-events-none`} />
      
      <div className="relative z-10 p-8 sm:p-10 flex flex-col items-center text-center">
        <h1 className={`text-4xl sm:text-5xl font-black uppercase tracking-widest mb-1 ${mainColor} drop-shadow-[0_0_15px_currentColor]`}>
          {text}
        </h1>
        <p className="text-[10px] sm:text-[11px] text-gray-500 uppercase tracking-widest mb-10 font-bold">
          Match Complete
        </p>

        <div className="w-full flex items-center justify-between px-2 mb-10">
          <div className="flex flex-col items-center">
            <span className="text-[10px] text-gray-500 uppercase font-bold tracking-wider mb-2">Your Score</span>
            <span className={`text-[36px] sm:text-[42px] font-black leading-none tracking-tight ${score >= oppScore ? 'text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]' : 'text-gray-600'}`}>
              {score}
            </span>
          </div>
          
          <div className="h-10 w-px bg-white/10" />

          <div className="flex flex-col items-center">
            <span className="text-[10px] text-gray-500 uppercase font-bold tracking-wider mb-2">Opp Score</span>
            <span className={`text-[36px] sm:text-[42px] font-black leading-none tracking-tight ${oppScore >= score ? 'text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]' : 'text-gray-600'}`}>
              {oppScore}
            </span>
          </div>
        </div>

        <button 
          onClick={() => navigate("/home")}
          className={`w-full py-4 rounded-xl text-white font-bold text-[14px] sm:text-[15px] uppercase tracking-widest hover:-translate-y-0.5 active:translate-y-0 transition-transform shadow-[0_6px_20px_rgba(0,0,0,0.3)] ${
            isWin ? 'bg-gradient-to-r from-green-600 to-emerald-600' : 
            isLoss ? 'bg-gradient-to-r from-red-600 to-rose-600' : 
            'bg-gradient-to-r from-gray-600 to-slate-600'
          }`}
        >
          Return to Arena
        </button>
      </div>
    </div>
  );
}

export default Winner;